import axios, { AxiosError } from "axios";

import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { UpdateSearchProfileRequestData } from "@/types";
import { GET_SEARCH_PROFILE } from "@/constants";

export const useUpdateSearchProfile = (onSuccess: () => void) => {
  const queryClient = useQueryClient();

  return useMutation<unknown, AxiosError, UpdateSearchProfileRequestData>({
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["search-profiles"], });
      onSuccess();
    },
    mutationFn: ({ updateObj }) =>
      axios
        .patch(`${GET_SEARCH_PROFILE}/${updateObj.id}`, updateObj)
        .then((res) => {
          return res.data;
        }),
    onError: (error) => {
      toast.error(error.message);
      console.error(error);
    },
  });
}
